import { FieldAdmin } from "pages/admin/verifications/QuickFieldAccess";
import { FieldFilterOptionsData } from "pages/app/all-field-view/components/FieldFilterOptions";

export const setLocalKlimVar = (item: string, value: unknown) => {
  const klimSession = JSON.parse(localStorage.getItem("klimSession") || "{}");
  const updated = { ...klimSession };
  updated[item] = value;
  return localStorage.setItem("klimSession", JSON.stringify(updated));
};

export const getLocalKlimVar = (item: string) => {
  const klimSession = JSON.parse(localStorage.getItem("klimSession") || "{}");
  if (localStorage.getItem(item)) {
    const value = localStorage.getItem(item);
    const updated = { ...klimSession };
    updated[item] = value;
    localStorage.setItem("klimSession", JSON.stringify(updated));
    localStorage.removeItem(item);
  }

  if (klimSession && Object.prototype.hasOwnProperty.call(klimSession, item)) {
    return klimSession[item];
  }
  return null;
};

export const clearLocalKlimVar = (item: string) => {
  const klimSession = JSON.parse(localStorage.getItem("klimSession") || "{}");
  const updated = { ...klimSession };
  if (updated[item]) {
    delete updated[item];
  }
  return localStorage.setItem("klimSession", JSON.stringify(updated));
};

export const getLocalVar = (item: string) => localStorage.getItem(item);

export const getLocalStorageZipCode = (): string | null => getLocalKlimVar("cropExplorerZipCode");
export const setLocalStorageZipCode = (value: string) => setLocalKlimVar("cropExplorerZipCode", value);

export const getLocalStorageHectare = (): number | null => getLocalKlimVar("cropExplorerHectare");
export const setLocalStorageHectare = (value: number) => setLocalKlimVar("cropExplorerHectare", value);

export const getLocalStorageCropExplorerPseudoUserId = (): string | null => getLocalKlimVar("cropExplorerPseudoUserId");
export const setLocalStorageCropExplorerPseudoUserId = (value: string) => setLocalKlimVar("cropExplorerPseudoUserId", value);
export const clearLocalStorageCropExplorerPseudoUserId = () => clearLocalKlimVar("cropExplorerPseudoUserId");

export const getLocalStorageCropExplorerOnboarded = (): boolean | null => getLocalKlimVar("cropExplorerOnboarded");
export const setLocalStorageCropExplorerOnboarded = (value: boolean) => setLocalKlimVar("cropExplorerOnboarded", value);

export const getLocalStorageCropExplorerDismissedOnboardingTour = (): boolean | null => getLocalKlimVar("cropExplorerDismissedOnboardingTour");
export const setLocalStorageCropExplorerDismissedOnboardingTour = (value: boolean) => setLocalKlimVar("cropExplorerDismissedOnboardingTour", value);

export const getLocalStorageShowFieldRecommendations = (): boolean | null => getLocalKlimVar("showFieldRecommendations");
export const setLocalStorageShowFieldRecommendations = (value: boolean) => setLocalKlimVar("showFieldRecommendations", value);

export const getNavbarOpenKeys = (): string | null => getLocalKlimVar("navbarOpenKeys");
export const setNavbarOpenKeys = (value: string) => setLocalKlimVar("navbarOpenKeys", value);

export const getAdminPreviousOpenFields = (): FieldAdmin[] | null => getLocalKlimVar("previousFields");
export const setAdminPreviousOpenFields = (value: FieldAdmin[]) => setLocalKlimVar("previousFields", value);

export const getLocalStorageFieldFilterOptions = (): FieldFilterOptionsData | null => {
  const farmFilterData = getLocalKlimVar("fieldFilterOptions");
  return farmFilterData || null;
};
export const setLocalStorageFieldFilterOptions = (data: FieldFilterOptionsData) => {
  setLocalKlimVar("fieldFilterOptions", data);
};
export const clearLocalStorageFieldFilterOptions = () => {
  clearLocalKlimVar("fieldFilterOptions");
};
